import { Col, Row } from "antd";

import TableAssessments, { IAssessmentTable } from "@/modules/tables/TableAssessments";
import { IClientTest } from "@/modules/assessments/types/test.interface";
import { AssessmentStatusFilter } from "@/modules/assessments/services/assessment-http.service";

export function DesktopAssessmentsListComponent({
  tableData,
  handleCreateNewAssessment,
  ...rest
}: {
  tableData: IAssessmentTable[];
  handleCreateNewAssessment: (type: string) => void;
  pageSize: number;
  currentPage: number;
  totalCount: number;
  setCurrentPage: (page: number) => void;
  onSortChange: (options: any) => void;
  sortOptions: { column: string | undefined; direction: string | undefined };
  loading: boolean;
  onAssessmentSearch: (q: string) => void;
  setPageSize: (size: number) => void;
  setTestNamesFilter: (value: string[]) => void;
  testNamesFilter: string[];
  tests: IClientTest[];
  onAssessmentClone: (assessment: IAssessmentTable) => void;
  status: AssessmentStatusFilter;
  onStatusChange: (status: AssessmentStatusFilter) => void;
}) {
  return (
    <Row gutter={30}>
      <Col xxl={24} xl={24} lg={24} md={24}>
        <TableAssessments dataList={tableData} onCreateAssessment={handleCreateNewAssessment} {...rest} />
      </Col>
    </Row>
  );
}
